import bus from '@/service/EventBus'

export default class Message {

  static success (messages, config) {
    this.show('success', messages, config)
  }

  static error (messages, config) {
    this.show('error', messages, config)
  }

  static warning (messages, config) {
    this.show('warning', messages, config)
  }

  static show (type, messages, config) {
    bus.$emit('show_message', type, messages, config)
  }
  static hide () {
    bus.$emit('hide_message')
  }
}



// WEBPACK FOOTER //
// ./src/service/Message.js